// NIGHT-DIRECTSTAFF-2026-10-23c §4: "Mark as test" on the candidate's page (once candidates.test_marked_at exists). A marked
// record leaves the lists, counts, Today and the duplicate check; "Not a test" brings it back. Nothing is deleted.
import React, { useState } from 'react';
import { isTestMarked } from './lib/candidateTest';

const btn = (bg, fg, off) => ({ background: bg, color: fg, borderRadius: 8, padding: '0 14px', minHeight: 44, fontSize: 13, fontWeight: 700, border: 0,
  cursor: off ? 'not-allowed' : 'pointer', opacity: off ? 0.5 : 1 });

/** candidate; mark(candidate, marked) -> throws plain words; toast */
export default function CandidateTestMark({ candidate, mark, toast = () => {} }) {
  const [busy, setBusy] = useState(false);
  const on = isTestMarked(candidate);
  const go = async () => {
    setBusy(true);
    try { await mark(candidate, !on); toast(on ? 'Not a test: back in the lists' : 'Marked as a test: hidden from the lists (Show tests brings it back)'); }
    catch (e) { toast(e.message || 'Not saved'); } finally { setBusy(false); }
  };
  return (
    <div data-testid="cand-test" style={{ marginTop: 8, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', fontSize: 12.5, color: '#475569' }}>
      {on && <span data-testid="cand-test-on" className="pill" style={{ background: '#ede9fe', color: '#5b21b6', fontWeight: 700 }}>{candidate.test_auto ? `Test record (${candidate.test_auto}): hidden automatically` : 'Test record: hidden from the lists'}</span>}
      {!candidate.test_auto && <button className="nb" data-testid="cand-test-toggle" disabled={busy} onClick={go} style={btn(on ? '#f1f5f9' : 'transparent', on ? '#334155' : '#6d28d9', busy)}>
        {busy ? 'Saving…' : on ? 'Not a test' : 'Mark as test'}</button>}
    </div>
  );
}
